import { gql } from '@apollo/client';

export const ASSIGN_PROPERTY_TO_AGENT = gql`
    mutation AssignPropertyToAgent($agentId: ID!, $propertyId: ID!) {
        assignPropertyToAgent(agentId: $agentId, propertyId: $propertyId) {
            id
            agentId
            propertyId
            assignedAt
            status
        }
    }
`;

export const UNASSIGN_PROPERTY_FROM_AGENT = gql`
    mutation UnassignPropertyFromAgent($agentId: ID!, $propertyId: ID!) {
        unassignPropertyFromAgent(agentId: $agentId, propertyId: $propertyId) {
            id
            agentId
            propertyId
            status
        }
    }
`;
